<cj-form-field class="position-relative">
  <div class="disabled-overlay" *ngIf="disabled"></div>
  <cj-form-label [class.required]="required" *ngIf="label">{{
    label
  }}</cj-form-label>
  <cj-icon
    *ngIf="iconPlacement === 'prefix'"
    cjPrefix
    [icon]="icon"
    pack="font-awesome-solid"
  ></cj-icon>
  <cj-icon
    *ngIf="iconPlacement === 'suffix'"
    cjSuffix
    [icon]="icon"
    pack="font-awesome-solid"
  ></cj-icon>
  <input
    cjInput
    #input
    autocomplete="off"
    list=""
    role="combobox"
    name="datalist"
    [value]="value || ''"
    (keydown)="onKeydown($event)"
    (input)="onInput($event.target.value)"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [fullWidth]="fullWidth"
  />
  <div id="datalist-wrapper" #overlay (click)="!disabled && onBlur()">
    <ul id="datalist" role="listbox" #datalist>
      <li
        *ngIf="withEmptyOption"
        (click)="onSelect('')"
        (mouseenter)="currentFocus = i"
        [value]=""
      ></li>
      <li
        *ngFor="
          let option of filteredOptions | slice: 0:offset;
          let i = index;
          trackBy: trackBy
        "
        [ngClass]="{
          active: i == currentFocus
        }"
        (click)="onSelect(option)"
        (mouseenter)="currentFocus = i"
        [value]="key ? option[key] : option"
      >
        {{ key ? option[key] : option }}
      </li>
      <button
        *ngIf="math.trunc(filteredOptions.length / offset)"
        class="btn btn-small btn-link m-auto"
        type="button"
        (click)="loadMore($event)"
      >
        Load More...
      </button>
    </ul>
  </div>
  <button
    cjSuffix
    cjButton
    ghost
    for="datalist"
    *ngIf="input.value.length && withClear && !disabled"
    status=""
    (click)="onClear()"
  >
    <cj-icon icon="times" pack="font-awesome-solid"> </cj-icon>
  </button>
</cj-form-field>
